module.exports = __webpack_public_path__ + "static/media/lzdIcon.94d646fd.svg";